import { Tooltip } from '@material-ui/core';
import React from 'react';

import { DoNotUseDemandSourceSettingsIcon } from '~/src/dash/components/icons/do-not-use-demand-source-settings-icon';

interface IDoNotUseDemandSourceSettingsIconWithTooltipProps {
  placement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
  width?: number;
  height?: number;
  title?: string;
}
export function DoNotUseDemandSourceSettingsIconWithTooltip({
  placement = 'top',
  width = 16,
  height = 16,
  title = 'Tier passed in bid response will be honored according to the mapping set under the demand source settings',
}: IDoNotUseDemandSourceSettingsIconWithTooltipProps) {
  return (
    <Tooltip title={title} placement={placement}>
      <span style={{ paddingLeft: '2px' }}>
        <DoNotUseDemandSourceSettingsIcon width={width} height={height} />
      </span>
    </Tooltip>
  );
}
